module.exports = __webpack_public_path__ + "img/slack.38ca3b8f.png";